module.exports = __webpack_public_path__ + "static/media/mode-70.7799993b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Containers/Workspace/Tools/GgbIcons/mode-70.svg
// module id = 1022
// module chunks = 2